module.exports = __webpack_public_path__ + "9788f41e/img/send-icon.3cfb6275.svg";